import * as cover from '../cover'

declare var pageData: cover.PageData
jQuery(() => { cover.main(pageData) })
